"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("../state"));
const isCatStarving_1 = __importDefault(require("./isCatStarving"));
const gameIsOngoing = () => state_1.default.isAwaitingFocus === false && state_1.default.isAtTitle === false && (0, isCatStarving_1.default)() === false && state_1.default.won === false;
exports.default = gameIsOngoing;
